import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import ImageSelect from './ImageSelect';
import { parseRequired } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-image-select',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const netteRules = container.getAttribute('data-nette-rules');
		const images = JSON.parse(container.getAttribute('images'));
		const required = parseRequired(container.getAttribute('required'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<ImageSelect
						name={name}
						isRequired={required}
						images={images}
						data-nette-rules={netteRules}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
